import { useQuery } from "@tanstack/react-query";
import { getClientDeals } from "@/api";
import { Deal } from "@/types";

export const useClientDeals = () => {
  const query = useQuery<Deal[]>({
    queryKey: ["clientDeals"],
    queryFn: () => getClientDeals(),
    staleTime: 1000 * 60 * 5,
  });

  return {
    ...query,
    data: query.data || [],
  }
};